import React from 'react';
import Ninja from '../../assets/images/ninja.png';
import Kinetic from '../../assets/images/Kinetic.gif';

import styled from 'styled-components';

const MainWrapper = styled.div`
margin: 0px 0px 0px;
max-width:100%;
border-radius:20px;
padding:20px;

p{
  text-align:center;
  font-size:17px;
  color:#a0a0a0;
  margin:0 30%;
  @media (max-width: 768px) {
    margin:0 0%;
    font-size:14px;
    margin-top:10px;
  }
}

h1{
  text-align:center;
  color:#000;
  font-weight:500;
  font-size:45px;
  font-family: var(--font-bold);
  @media (max-width: 768px) {
    font-size:22px;
  }
}
`;

const Audits = styled.div`
  display: grid;
  margin-top: 20px;
  width: 100%;
  padding: 40px 120px 20px 120px;
  grid-template-columns: 1fr 1fr;
  gap: 80px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 20px;
    padding: 20px 30px;
  }

  .auditkyc {
    border-radius: 15px;
    background-color: #f4f4f4;
    padding: 25px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    }

    .icon-container {
      width: 100%;
      display: flex;
      border-radius: 10px;
      justify-content: center;
      align-items: center;

      .icon {
        font-size: 40px;
        color: #784dcc;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.2);
        }
      }
    }

    .title {
      font-size: 20px;
      font-weight: 600;
      font-family: var(--font-normal);
      text-align: center;
      margin-top: 10px;
    }

    .description {
      padding: 0;
      margin: 0;
      text-align: left;
      font-size: 13px;
      margin-top: 6px;
    }

    .explore-link {
      display: flex;
      align-items: center;
      transition: transform 0.3s ease, color 0.3s ease;

      &:hover {
        transform: translateY(-3px);
        color: #ffba00;
      }

      .arrow {
        width: 20px;
        height: 20px;
        margin-bottom: 0;
        transition: transform 0.3s ease;
      }

      &:hover .arrow {
        transform: translateX(5px);
      }
    }
  }

  img {
    margin-bottom: 20px;
    width: 160px;
    height: 160px;
  }
`;

const BlockThree: React.FC = () => {
  return (
    <div className="blockthree-wrapper apoplsp" style={{ margin: 0 }}>
      <MainWrapper>
        <h1>Official Vendor of <span style={{ color: '#784dcc' }}>NinjaTrader</span></h1>
        <p>We are proud to partner with some of the most innovative and trusted companies in the industry.</p>
        <Audits>
          <a href="http://ninjatrader.com/GetStarted" target="_blank">
            <img style={{ width: '100%', height: '100%' }}
              src={Ninja} alt="Ninja" />
          </a>
          <img style={{ width: '100%', height: '100%' }}
            src={Kinetic} alt="Kinetic" />
        </Audits>
      </MainWrapper>
    </div>
  );
};

export default BlockThree;
